import { render, staticRenderFns } from "./EditTop.vue?vue&type=template&id=c8bd0448&"
import script from "./EditTop.vue?vue&type=script&lang=js&"
export * from "./EditTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports